import React from "react";
import ReactApexChart from "react-apexcharts";

const Barcharts = () => {
  const series = [
    {
      name: "Direct",
      data: [12.45, 16.2, 8.9, 11.42, 12.6, 17.1, 17.2, 14.16, 11.1],
    },
    {
      name: "Indirect",
      data: [-11.45, -15.42, -7.9, -12.42, -12.6, -17.1, -17.2, -14.16, -11.1],
    },
  ];
  var option: any = {
    chart: {
      type: "bar",
      height: 350,
      stacked: true,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        columnWidth: "20%",
      },
    },
    colors: ["#323a46", "#6a69f5"],
    fill: {
      opacity: 1,
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: false,
    },
    yaxis: {
      labels: {
        formatter: function (y: any) {
          return y.toFixed(0) + "%";
        },
      },
    },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
      ],
      labels: {
        rotate: -90,
      },
    },
  };
  return (
    <React.Fragment>
      <ReactApexChart
        type="bar"
        series={series}
        options={option}
        id="barchartcenter"
        dir="ltr"
        height={300}
      />
    </React.Fragment>
  );
};

const SplineChart = () => {
    
const series = [
    {
        name: "New Visits",
        data: [0, 60, 20, 90, 45, 110, 55, 130, 44, 110, 75, 120],
    },
    {
        name: "Unique Visits",
        data: [0, 45, 10, 75, 35, 94, 40, 115, 30, 105, 65, 110],
    },
];
var option : any = {
    chart: {
        height: 350,
        type: "area",
        stacked: true,
        toolbar: {
            show: false,
            autoSelected: "zoom",
        },
    },
    colors: ["#6a69f5", "#323a46"],
    dataLabels: {
        enabled: false,
    },
    stroke: {
        curve: "smooth",
        width: [3, 3],
        dashArray: [0, 4],
        lineCap: "round",
    },
    grid: {
        borderColor: "#e8e8e8",
        padding: {
            left: 0,
            right: 0,
        },
        strokeDashArray: 4,
    },
    markers: {
        size: 0,
        hover: {
            size: 0,
        },
    },
    xaxis: {
        type: "month",
        categories: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
        ],
        axisBorder: {
            show: true,
            color: "#e8e8e8",
        },
        axisTicks: {
            show: true,
            color: "#e8e8e8",
        },
    },
    fill: {
        type: "gradient",
        gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.4,
            opacityTo: 0.3,
            stops: [0, 90, 100],
        },
    },

    tooltip: {
        x: {
            format: "dd/MM/yy HH:mm",
        },
    },
    legend: {
        position: "top",
        horizontalAlign: "right",
    },
}

    return (
        <React.Fragment>
          <ReactApexChart
            type="area"
            series={series}
            options={option}
            id="apex_area1"
            dir="ltr"
            height={300}
          />
        </React.Fragment>
      );
};

const BasicDonughtChart = () => {

    const series = [38.6, 22.5, 30.8, 8.1];
    var options: any = {
        chart: {
            height: 300,
            type: "donut",
            zoom: {
                enabled: false,
            },
            toolbar: {
                show: false,
            },
        },
        stroke: {
            show: false,
        },
        labels: ["United States", "Canada", "Mexico", "Other"],
        colors: ["#6a69f5", "#323a46", "#50cd89", "#94989a"],
        responsive: [
            {
                breakpoint: 480,
                options: {
                    chart: {
                        width: 200,
                    },
                },
            },
        ],
        legend: {
            position: "bottom",
        },
    }

    return (
        <React.Fragment>
          <ReactApexChart
            type="donut"
            series={series}
            options={options}
            id="basicbonut"
            dir="ltr"
            height={300}
          />
        </React.Fragment>
      );
};

const DoughnutChart = () => {

    const series = [67];
    var options : any = {
        chart: {
            height: 280,
            type: "radialBar",
        },
        colors: ["#6a69f5"],
        plotOptions: {
            radialBar: {
                startAngle: -90,
                endAngle: 90,
                track: {
                    background: "#323a46",
                    startAngle: -90,
                    endAngle: 90,
                },
                dataLabels: {
                    name: {
                        show: false,
                    },
                    value: {
                        fontSize: "20px",
                        show: true,
                    },
                },
            },
        },
        fill: {
            type: "gradient",
            gradient: {
                shade: "light",
                type: "horizontal",
                gradientToColors: ["#6a69f5"],
                stops: [0, 100],
            },
        },
        stroke: {
            lineCap: "butt",
        },
        labels: ["Progress"],
    }
    return (
        <React.Fragment>
          <ReactApexChart
            type="radialBar"
            series={series}
            options={options}
            id="doughnutchart"
            dir="ltr"
            height={280}
          />
        </React.Fragment>
      );
}

export { Barcharts, SplineChart, BasicDonughtChart, DoughnutChart };
